import { decodeHexResponse } from '../_common/common.utils';
import TransferEmployeeTypes from './TransferEmployee.types';

const INITIAL_STATE = {
	transferEmployeeResponse: null,
	allTransfersData: null,
	deleteTransferResponse: null,
};

const transferEmployeeDetailsReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case TransferEmployeeTypes.TRANSFER_EMPLOYEE_START:
			return { ...state, transferEmployeeResponse: null };
		case TransferEmployeeTypes.TRANSFER_EMPLOYEE_SUCCESS:
			return {
				...state,
				transferEmployeeResponse: decodeHexResponse(
					action.payload,
					'fetchTransferEmployeeKey',
				),
			};
		case TransferEmployeeTypes.TRANSFER_EMPLOYEE_FAILURE:
			return {
				...state,
				transferEmployeeResponse: decodeHexResponse(
					action.payload,
					'fetchTransferEmployeeKey',
				),
			};
		case TransferEmployeeTypes.TRANSFER_EMPLOYEE_RESPONSE_CHANGED:
			return { ...state, transferEmployeeResponse: null };
		case TransferEmployeeTypes.TRANSFER_EMPLOYEE_RESPONSE_REST_START:
			return { ...state, transferEmployeeResponse: null };

		// Get All Transfers
		case TransferEmployeeTypes.GET_ALL_TRANSFERS_START:
			return { ...state, allTransfersData: null };
		case TransferEmployeeTypes.GET_ALL_TRANSFERS_SUCCESS:
			// Check if response is encrypted (has response field) or plain error
			if (action.payload?.response) {
				return {
					...state,
					allTransfersData: decodeHexResponse(action.payload, 'fetchAllTransfersKey'),
				};
			} else {
				// Plain response (shouldn't happen for success, but handle it)
				return {
					...state,
					allTransfersData: action.payload,
				};
			}
		case TransferEmployeeTypes.GET_ALL_TRANSFERS_FAILURE:
			// Error responses are not encrypted, return as-is
			return {
				...state,
				allTransfersData: action.payload,
			};
		case TransferEmployeeTypes.GET_ALL_TRANSFERS_RESPONSE_REST_START:
			return { ...state, allTransfersData: null };

		// Delete Transfer
		case TransferEmployeeTypes.DELETE_TRANSFER_START:
			return { ...state, deleteTransferResponse: null };
		case TransferEmployeeTypes.DELETE_TRANSFER_SUCCESS:
			return {
				...state,
				deleteTransferResponse: decodeHexResponse(action.payload, 'deleteTransferKey'),
			};
		case TransferEmployeeTypes.DELETE_TRANSFER_FAILURE:
			return {
				...state,
				deleteTransferResponse: decodeHexResponse(action.payload, 'deleteTransferKey'),
			};
		case TransferEmployeeTypes.DELETE_TRANSFER_RESPONSE_REST_START:
			return { ...state, deleteTransferResponse: null };

		default:
			return state;
	}
};

export default transferEmployeeDetailsReducer;
